<template>
  <div class="connected" v-if="connected">
      Vous êtes maintenant connecté ! 
  </div>
  <div ref="wrapper" v-else-if="page && twoFactor">
      <page-image-avatar class="avatar" :page="page"/>
      <p class="name">{{page.name}}</p>
      <div class="description">
          <p v-if="twoFactor.verification_method == 0">
              Veuillez renseinger ci-dessous le code de verification recu sur l'application 
              vous permettant d'effectuer vos authentifications à deux facteurs et cliquez sur le bouton ci-dessous :
          </p>
          <p v-if="twoFactor.verification_method == 1">
              Veuillez renseinger ci-dessous le code de verification recu par SMS et cliquez sur le bouton ci-dessous :
          </p>
          <p v-if="twoFactor.verification_method == 4">
              Veuillez accepter l'appareil {{page.story_config.user_agent.split(';')[4]}} depuis la notification envoyée 
              par votre application Instagram et cliquez sur le bouton ci-dessous :
          </p>
          <p v-if="twoFactor.verification_method == 99">
              Veuillez accepter l'appareil {{page.story_config.user_agent.split(';')[4]}} depuis la notification envoyée 
              par votre application Instagram ou entrer le code recu par SMS puis cliquez sur le bouton ci-dessous :
              (Si vous etes dans le cas d'une notification, laissez le champs ci-dessous vide)
          </p>
          <p v-if="twoFactor.verification_method == 98">
              Veuillez  entrer le code recu par Email ou SMS puis cliquez sur le bouton ci-dessous :
          </p>
      </div>
      <div class="interract">
        <input v-model="code" class="code" v-if="twoFactor.verification_method != 4" type="number">
        <button ref="connect-btn" @click="connectApi" class="connect-btn" :disabled="(twoFactor.verification_method != 4) && (!code)">Connecter</button>
        <div v-if="twoFactor.verification_method == 98"><p>{{$t("dash.pages.linkedin_code")}}</p><button class="connect-btn" @click="resendCode">{{$t("dash.pages.linkedin_code_btn")}}</button></div>
      </div>
      <p v-if="error_response" class="error-return">{{error_response}}</p>
      <p v-if="info_response" class="info-return">{{info_response}}</p>
  </div>
  <div ref="wrapper" v-else class="description">
      Erreur la page n'existe pas ou n'a pas besoin d'authentifiacation à deux facteurs.
  </div>
</template>

<script>

import PageImageAvatar from './PageImageAvatar.vue'
import Bots from '../mixins/Bots'
import Button from './utils/button.vue'

export default {

    props: {
        pageid: [String, Boolean],
        pages: Array,
        createPage: Boolean
    },
    data() {
        return {
            code: '',
            error_response: '',
            info_response: '',
            connected: false
        }
    },
    mixins: [Bots],
    components: {
        PageImageAvatar,
        Button
    },
    watch: {
        pages: function(val) {
            // this.$vs.loading.close(this.$refs.wrapper)
            // console.log("LES PAGES", this.page, this.twoFactor);
        }
    },
    computed: {
        page() {
            if (!this.pages || this.pages.length === 0) return null;
            return this.pages.find(e => e.id === this.pageid);
        },

        twoFactor() {
            if (!this.page || !this.page.story_config || (!this.page.story_config.two_factor && !this.page.story_config.checkpoint && !this.page.story_config.challenge_informations && !this.page.story_config.challenge)) return null;
            if (this.page.story_config.two_factor) {
                return JSON.parse(this.page.story_config.two_factor);
            }
            if (this.page.story_config.checkpoint) {
                return {verification_method: 99};
            }
            if (this.page.story_config.challenge_informations || this.page.story_config.challenge) {
                return {verification_method: 98};
            }
        }
    },
    methods: {

        connectApi() {
            this.info_response = '';
            this.error_response = '';
            if ((this.twoFactor.verification_method == 98 && this.code.length > 0) || this.code.length === 6 || this.twoFactor.verification_method == 4 || this.twoFactor.verification_method == 99) {
                this.$vs.loading({container: this.$refs['connect-btn']})
                this.twoFactorLinkedinConnect({
                    verificationCode: this.code,
                    pageId: this.page.id,
                    createPage: this.createPage
                }).then(r => {
                    console.log(r);
                    this.$vs.loading.close(this.$refs['connect-btn']);
                    if (r.ok && r.body && r.body.connected) {
                        this.connected = true;
                        this.$emit('closePopup');    
                        this.$emit('getPagesEvent')
                    } else {
                        this.error_response = `${r.status}: ${r.body.msg}`
                    }
                })
            }
            else if (this.code.length === 6 || this.twoFactor.verification_method == 4 || this.twoFactor.verification_method == 99) {
                // OLD CONNECT INSTAGRAM
                console.log(this.$refs);
                this.$vs.loading({container: this.$refs['connect-btn']})
                console.log("CONNECTION");
                this.twoFactorInstagramConnect({
                    pageId: this.page.id,
                    accountId: this.page.account,
                    verificationCode: this.code
                }).then(r => {
                    console.log(r);
                    this.$vs.loading.close(this.$refs['connect-btn'])
                    if (r.ok && r.body && r.body.ok) {
                        this.connected = true;
                        // this.$router.push({name: 'overview'})
                        this.$emit('getPagesEvent')
                    } else {
                        this.error_response = `${r.status}: ${r.bodyText}`
                    }
                });
            }
        },
        resendCode() {
            this.info_response = '';
            this.error_response = '';
            this.twoFactorLinkedinResendCode({
                pageId: this.page.id
            }).then(r => {
                console.log("twoFactorLinkedinResendCode",r);
                if (r.ok && r.body && r.body.success && r.body.resend) {
                    this.info_response = this.$t("dash.pages.linkedin_code_success");
                } else {
                    this.error_response = `${r.status}: ${r.body.msg}`
                }
            })
        }
    }

}
</script>
